import { Expose, Type } from 'class-transformer'

import { BookmarkType } from './BookmarkType'

export class BookmarkListResponse {
  @Expose()
  @Type(() => BookmarkType)
  data: BookmarkType[]

  @Expose()
  total: number
}
